import request from '@/plugins/axios'


//删除回调信息
export function deleteCallback(params) {
  return request({
    url: '/callback/deleteCallback/' + params,
    method: 'get'
  })
}

//创建回调信息
export function addCallback(data) {
  return request({
    url: '/callback/addCallback',
    method: 'post',
    data
  })
}

//创建回调日志
export function addCallbackLog(data) {
  return request({
    url: '/callback/addCallbackLog',
    method: 'post',
    data
  })
}

//查询单个回调信息
export function getCallback(params) {
  return request({
    url: '/callback/getCallback/' + params,
    method: 'get'
  })
}

//查询单个回调日志
export function getCallbackLog(params) {
  return request({
    url: '/callback/getCallbackLog/' + params,
    method: 'get'
  })
}

//获取回调信息列表
export function listCallback(params) {
  return request({
      url: '/callback/listCallback',
      method: 'get',
      params
  })
}

//获取回调日志列表
export function listCallbackLog(params) {
  return request({
      url: '/callback/listCallbackLog',
      method: 'get',
      params
  })
}



//修改回调信息
export function updateCallback(data) {
  return request({
      url: '/callback/updateCallback',
      method: 'post',
      data
  })
}


//获取可用回调动作清单
export function getCallbackActionTemplate() {
  return request({
      url: '/callback/getCallbackActionTemplate',
      method: 'get'
  })
}